// modules
import { Modal } from "antd";

// components
import Dialog from "components/molecules/Dialog/Dialog";

type CountDownProps = {
	closable?: boolean;
	timer: number;
	title?: string;
	subtitle?: string;
	errorIcon?: boolean;
	okButton?: {
		label: string;
		onClick?: () => void;
	};
	onTimeComplete?: () => void;
};

const CountDownModalContainer = ({ closable, timer, title, subtitle, okButton, onTimeComplete, errorIcon }: CountDownProps) => {
	const secondsToGo = timer;

	const modal = Modal.confirm({});

	modal.update({
		content: <Dialog errorIcon={errorIcon} title={title} subtitle={subtitle} destroy={modal.destroy} okButton={okButton} />,
		centered: true,
		icon: null,
		closable: closable,
		okButtonProps: { hidden: true },
		cancelButtonProps: { hidden: true },
		width: "28.125rem",
		bodyStyle: { padding: 0, margin: 0 },
		className: "cag_modal"
	});

	setTimeout(() => {
		modal.destroy();
		if (onTimeComplete) {
			onTimeComplete();
		}
	}, secondsToGo * 1000);

	return null;
};

export default CountDownModalContainer;
